import { NotificationType } from '../components/Notifications/Notifications'
import { useCallback, useState } from 'react'

export function useNotifications() {
  const [notifications, setNotifications] = useState<NotificationType[]>([])

  const addNotification = useCallback((notification: Omit<NotificationType, 'id'>) => {
    const newNotification: NotificationType = {
      id: Date.now(),
      ...notification,
    }
    setNotifications(prev => [...prev, newNotification])
  }, [])

  const removeNotification = useCallback((id: number) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }, [])

  return {
    notifications,
    addNotification,
    removeNotification,
  }
}
